import { render, staticRenderFns } from "./CamType.vue?vue&type=template&id=20f0a09d&scoped=true&"
import script from "./CamType.vue?vue&type=script&lang=js&"
export * from "./CamType.vue?vue&type=script&lang=js&"
import style0 from "./CamType.vue?vue&type=style&index=0&id=20f0a09d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f0a09d",
  null
  
)

export default component.exports